import { boardSettingsQueryConfigParamValues } from '../../../common/constants';
import messages from './messages';

export const MENU_ITEMS = [
	{
		id: 'general',
		configQuery: boardSettingsQueryConfigParamValues.general,
		name: messages.generalMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'columns',
		configQuery: boardSettingsQueryConfigParamValues.columns,
		name: messages.columnsMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'swimlanes',
		configQuery: boardSettingsQueryConfigParamValues.swimlanes,
		name: messages.swimlanesMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'quickFilters',
		configQuery: boardSettingsQueryConfigParamValues.quickFilters,
		name: messages.quickFiltersMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'cardColors',
		configQuery: boardSettingsQueryConfigParamValues.cardColors,
		name: messages.cardColoursMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'cardLayout',
		configQuery: boardSettingsQueryConfigParamValues.cardLayout,
		name: messages.cardLayoutMenuItemLabelNonFinal,
		jsmAllowed: true,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'estimation',
		configQuery: boardSettingsQueryConfigParamValues.estimation,
		name: messages.estimationMenuItemLabelNonFinal,
		jsmAllowed: false,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'time',
		configQuery: boardSettingsQueryConfigParamValues.workingDays,
		name: messages.workingDaysMenuItemLabelNonFinal,
		jsmAllowed: false,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'timeline',
		configQuery: boardSettingsQueryConfigParamValues.timeline,
		name: messages.timelineMenuItemLabelNonFinal,
		jsmAllowed: false,
		userLocatedBoardAllowed: true,
	},
	{
		id: 'insights',
		configQuery: boardSettingsQueryConfigParamValues.insights,
		name: messages.insightsMenuItemLabelNonFinal,
		jsmAllowed: false,
		userLocatedBoardAllowed: false,
	},
];
